import { useFloating as useFloatingUi, shift, size, flip, offset, hide, inline, autoUpdate, limitShift } from '@floating-ui/react';
const POPOVER_PADDING = 4;
/**
 * Shared hook for floating-ui positioning logic used by Popover and other overlay components.
 * Encapsulates the standard middleware chain with extension points for custom middleware.
 */ export function useFloating({ nodeId, placement, floatingStrategy, offsetValue = POPOVER_PADDING, inlineEnabled, flipEnabled = true, fallbackPlacements, hideOptions, shiftEnabled = true, shiftOptions = {}, sizeOptions, open, onOpenChange, additionalMiddleware = [] }) {
    const floating = useFloatingUi({
        nodeId,
        placement,
        strategy: floatingStrategy,
        whileElementsMounted: autoUpdate,
        middleware: [
            inlineEnabled && inline(),
            offset(offsetValue),
            (hideOptions === null || hideOptions === void 0 ? void 0 : hideOptions.referenceHidden) && hide(),
            hide({
                strategy: 'escaped'
            }),
            flip(({ middlewareData })=>{
                var _middlewareData_hide, _middlewareData_hide1;
                return {
                    fallbackPlacements,
                    mainAxis: flipEnabled,
                    crossAxis: fallbackPlacements && fallbackPlacements.length > 0 ? placement === null || placement === void 0 ? void 0 : placement.includes('-') : flipEnabled,
                    altBoundary: middlewareData === null || middlewareData === void 0 ? void 0 : (_middlewareData_hide = middlewareData.hide) === null || _middlewareData_hide === void 0 ? void 0 : _middlewareData_hide.escaped,
                    /**
         * The `bestFit` strategy doesn't play nicely when comparing
         * overflows that are very close to each other (e.g. less than 1px difference).
         * When paired with the `altBoundary` option, this can cause the popover to
         * flip into a position that is clipped by the viewport.
         */ fallbackStrategy: (middlewareData === null || middlewareData === void 0 ? void 0 : (_middlewareData_hide1 = middlewareData.hide) === null || _middlewareData_hide1 === void 0 ? void 0 : _middlewareData_hide1.escaped) ? 'initialPlacement' : 'bestFit'
                };
            }),
            sizeOptions && size({
                padding: sizeOptions.padding || POPOVER_PADDING,
                altBoundary: sizeOptions.altBoundary,
                apply ({ availableHeight, availableWidth, elements, rects }) {
                    var _elements_floating;
                    // intentionally using style here to avoid generating a new class
                    // for each pixel value of width|max{width|height}.
                    const style = ((_elements_floating = elements.floating) === null || _elements_floating === void 0 ? void 0 : _elements_floating.style) || {};
                    if (sizeOptions.maxWidth) {
                        Object.assign(style, {
                            maxWidth: `${availableWidth}px`
                        });
                    }
                    if (sizeOptions.maxHeight) {
                        Object.assign(style, {
                            maxHeight: `${availableHeight}px`
                        });
                    }
                    if (sizeOptions.matchWidth) {
                        Object.assign(style, {
                            width: `${rects.reference.width}px`
                        });
                    }
                }
            }),
            shift({
                mainAxis: shiftEnabled,
                padding: shiftOptions.padding || POPOVER_PADDING,
                altBoundary: shiftOptions.altBoundary,
                limiter: limitShift()
            }),
            ...additionalMiddleware
        ].filter(Boolean),
        open,
        onOpenChange
    });
    return floating;
}

//# sourceMappingURL=useFloating.js.map